import { DatePicker } from "@mui/x-date-pickers";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import Panel from "@/layout/Panel";
import PanelTitle from "@/layout/PanelTitle";

import { useDriverStatusContext } from "../DriverStatusContext";

function DriverStatusPanel({ children }: { children: ReactNode }) {
    const { t } = useTranslation();
    const { month, updateMonth } = useDriverStatusContext();

    return (
        <Panel
            title={
                <PanelTitle title={t("staff")}>
                    <div className="   col-span-12 md:col-span-6 grid grid-cols-2   gap-2">
                        <DatePicker
                            className=" md:col-start-2"
                            label={t("month_and_year")}
                            views={["month", "year"]}
                            value={month}
                            onChange={(date) => {
                                if (date) updateMonth(date);
                            }}
                        />
                    </div>
                </PanelTitle>
            }
        >
            {children}
        </Panel>
    );
}

export default DriverStatusPanel;
